import styled from "styled-components";

export const AmusnetWidgetLabelContainerDefaultBox = styled.div`
    position: absolute;
    top: -40%;
    left: 50%;
    transform: translateX(-50%);
   
    border-radius: 21px;
    background: #240052;
    padding: 0.2rem 1rem;
    box-shadow: 0px 2px 4px 0px #1F0861BF, 
    0px 1px 4px 0px #7FF80099 inset,
    0px -1px 4px 0px #FCE40380 inset;
    
    @media ${({theme}) => theme.mediaQuery.sAndAbove} {
        top: -50%;
        padding: 0.5rem 1rem;
    }

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        top: -30%;
    }
`;
